import { useLogs } from "~~/composables/useLogs";


export default defineNuxtPlugin(({ vueApp }) => {
  useLogs().setup();
  vueApp.config.errorHandler = (error, context) => {
    useLogs().trackException(error as Error)
  }

  window.addEventListener('unhandledrejection', function (rejection) {
    useLogs().trackException(rejection.reason as Error);
    return false;
  })
});


